export default __webpack_public_path__ + "static/media/Logo.0d0ed058.svg";